import { Navigate } from "react-router-dom";
import ProtectedLayout from "@/components/layout/ProtectedLayout";
import ProtectedRoute from "@/features/auth/components/ProtectedRoute";
import Home from "@/pages/Home";
import AccountManagement from "@/pages/AccountManagement";
import AWSReports from "@/pages/aws/AWSReports";
import RDSReports from "@/pages/aws/RDSReports";
import EFSReports from "@/pages/aws/EFSReports";
import AWSAccountsReports from "@/pages/aws/AWSAccountsReports";
import CreateAccount from "@/pages/aws/CreateAccount";
import UserManagement from "@/pages/aws/UserManagement";
import PermissionSets from "@/pages/aws/PermissionSets";
import EC2Reports from "@/pages/aws/EC2Reports";
import S3Reports from "@/pages/aws/S3Reports";
import ADUsersGroupReports from "@/pages/aws/ADUsersGroupReports";
import IAMReports from "@/pages/aws/IAMReports";
import LambdaReports from "@/pages/aws/LambdaReports";
import MonthlyCostsReports from "@/pages/aws/MonthlyCostsReports";
import AWSHealthEvents from "@/pages/aws/HealthEventsReports";
import TrustedAdvisorReports from "@/pages/aws/TrustedAdvisorReports";
import ComputeOptimizerReports from "@/pages/aws/ComputeOptimizerReports";
import KpiReports from "../pages/aws/KpiReports";
import CostIntelligenceReports from "../pages/aws/CostIntelligenceReports";
import ItComplianceReports from "../pages/aws/ItComplianceReports";
import NetworkingReports from "../pages/aws/NetworkingReports";
import BedrockReports from "../pages/aws/BedrockAgentReports";
import QuickReports from "../pages/aws/QuickReports";
import KiroReports from "../pages/aws/KiroReports";
import CoworkReports from "../pages/aws/ClaudeCoworkBedrockReports";
import DevopsAgentReports from "../pages/aws/DevopsAgentReports";
import SagemakerReports from "../pages/aws/SagemakerReports";
import EKSReports  from "../pages/aws/EKSReports";
import HealthOpsChatPage from "../pages/aws/HealthOpsChat";
import AWSAgents from "../pages/aws/AWSAgents";
import WIZ from "@/pages/wiz/WIZ";
import AzureReports from "@/pages/azure/AzureReports";
import GCPReports from "@/pages/gcp/GCPReports";
import OCIReports from "@/pages/oci/OCIReports";
import BulkEmail from "@/pages/email/BulkEmail";
import DatadogAwsConsoleLogin from "@/pages/aws/DatadogAwsConsole"
import DatadogGcp from "@/pages/gcp/DatadogGcp"
// AWS LCCS (OutpostForge) module pages
import { CapacityManagement } from "@/features/outpostforge/pages/CapacityManagement";
import { EditCapacity } from "@/features/outpostforge/pages/EditCapacity";
import { TaskMonitor } from "@/features/outpostforge/pages/TaskMonitor";
import { Sandbox as OutpostSandbox } from "@/features/outpostforge/pages/Sandbox";
import { Settings as OutpostSettings } from "@/features/outpostforge/pages/Settings";

export const protectedRoutes = [
  {
    path: "/",
    element: <ProtectedLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "accounts",
        element: <ProtectedRoute requiredPage="accounts">
        <AccountManagement />
        </ProtectedRoute>,
        children: [
          {
            index: true,
            element: <AccountManagement />,
          },
        ],
      },
      {
        path: "aws",
        children: [
          {
            path: "reports",
            element: <ProtectedRoute requiredPage="aws/reports">
              <AWSReports />
            </ProtectedRoute>,
          },
          {
            path: "reports/rds",
            element: <ProtectedRoute requiredPage="aws/reports/rds">
              <RDSReports />
            </ProtectedRoute>
          },
          {
            path: "reports/efs",
            element: <ProtectedRoute requiredPage="aws/reports/efs">
              <EFSReports />
            </ProtectedRoute>
          },
          {
            path: "reports/ec2",
            element: <ProtectedRoute requiredPage="aws/reports/ec2">
              <EC2Reports />
            </ProtectedRoute>
          },
          {
            path: "reports/s3",
            element: <ProtectedRoute requiredPage="aws/reports/s3">
              <S3Reports />
            </ProtectedRoute>
          },
          {
            path: "reports/ad",
            element: <ProtectedRoute requiredPage="aws/reports/ad">
              <ADUsersGroupReports />
            </ProtectedRoute>
          },
          {
            path: "reports/iam",
            element: <ProtectedRoute requiredPage="aws/reports/iam">
              <IAMReports />
            </ProtectedRoute>
          },
          {
            path: "reports/accounts",
            element: <ProtectedRoute requiredPage="aws/reports/accounts">
              <AWSAccountsReports />
            </ProtectedRoute>
          },
          {
            path: "reports/monthly-costs",
            element: <ProtectedRoute requiredPage="aws/reports/monthly-costs">
              <MonthlyCostsReports />
            </ProtectedRoute>
          },
          {
            path: "reports/aws-health-events",
            element: <ProtectedRoute requiredPage="aws/reports/aws-health-events">
              <AWSHealthEvents />
            </ProtectedRoute>
          },
          {
            path: "reports/trusted-advisor-organizational",
            element: <ProtectedRoute requiredPage="aws/reports/trusted-advisor-organizational">
              <TrustedAdvisorReports />
            </ProtectedRoute>
          },
          {
            path: "reports/compute-optimizer",
            element: <ProtectedRoute requiredPage="aws/reports/compute-optimizer">
              <ComputeOptimizerReports />
            </ProtectedRoute>
          },
          {
            path: "reports/kpi",
            element: <ProtectedRoute requiredPage="aws/reports/kpi">
              <KpiReports />
            </ProtectedRoute>
          },
          {
            path: "reports/cost-intelligence",
            element: <ProtectedRoute requiredPage="aws/reports/cost-intelligence">
              <CostIntelligenceReports />
            </ProtectedRoute>
          },
          {
            path: "reports/datadog-aws-console",
            element: <ProtectedRoute requiredPage="aws/reports/datadog-aws-console">
              <DatadogAwsConsoleLogin />
            </ProtectedRoute>
          },
          {
            path: "reports/lambda",
            element: <ProtectedRoute requiredPage="aws/reports/lambda">
              <LambdaReports />
            </ProtectedRoute>
          },
          {
            path: "reports/networking",
            element: <ProtectedRoute requiredPage="aws/reports/networking">
              <NetworkingReports />
            </ProtectedRoute>
          },
          {
            path: "reports/eks",
            element: <ProtectedRoute requiredPage="aws/reports/eks">
              <EKSReports />
            </ProtectedRoute>
          },
          {
            path: "reports/bedrock",
            element: <ProtectedRoute requiredPage="aws/reports/bedrock">
              <BedrockReports />
            </ProtectedRoute>
          },
          {
            path: "reports/claude-cowork-bedrock",
            element: <ProtectedRoute requiredPage="aws/reports/claude-cowork-bedrock">
              <CoworkReports/>
            </ProtectedRoute>
          },
          {
            path: "reports/devops-agent",
            element: <ProtectedRoute requiredPage="aws/reports/devops-agent">
              <DevopsAgentReports />
            </ProtectedRoute>
          },
          {
            path: "reports/sagemaker",
            element: <ProtectedRoute requiredPage="aws/reports/sagemaker">
              <SagemakerReports />
            </ProtectedRoute>
          },
          {
            path: "reports/quick",
            element: <ProtectedRoute requiredPage="aws/reports/quick">
              <QuickReports />
            </ProtectedRoute>
          },
          {
            path: "reports/kiro",
            element: <ProtectedRoute requiredPage="aws/reports/kiro">
              <KiroReports />
            </ProtectedRoute>
          },
          {
            path: "reports/it-compliance",
            element: <ProtectedRoute requiredPage="aws/reports/it-compliance">
              <ItComplianceReports />
            </ProtectedRoute>
          },
          {
            path: "create-account",
            element: <ProtectedRoute requiredPage="aws/create-account">
              <CreateAccount />
            </ProtectedRoute>
          },
          {
            path: "user-management",
            element: <ProtectedRoute requiredPage="aws/user-management">
              <UserManagement />
            </ProtectedRoute>
          },
          {
            path: "permission-sets",
            element: <ProtectedRoute requiredPage="aws/permission-sets">
              <PermissionSets />
            </ProtectedRoute>
          },
          {
            path: "agents",
            element: <ProtectedRoute requiredPage="aws/agents">
              <AWSAgents />
            </ProtectedRoute>
          },
          {
            path: "agents/healthops",
            element: <ProtectedRoute requiredPage="aws/agents/healthops">
              <HealthOpsChatPage />
            </ProtectedRoute>
          },
        ],
      },
      {
        path: "azure",
        children: [
          {
            path: "reports",
            element: <ProtectedRoute requiredPage="azure/reports">
              <AzureReports />
            </ProtectedRoute>,
            children: [
              {
                index: true,
                element: <AzureReports  />,
              },
            ]
          },
        ],
      },
      {
        path: "gcp",
        children: [
          {
            path: "reports",
            element: <ProtectedRoute requiredPage="gcp/reports">
              <GCPReports />
            </ProtectedRoute>,
          },
          {
            path: "reports/datadog-gcp",
            element: <ProtectedRoute requiredPage="gcp/reports/datadog-gcp">
              <DatadogGcp />
            </ProtectedRoute>
          },
        ],
      },
      {
        path: "oci",
        children: [
          {
            path: "reports",
            element: <ProtectedRoute requiredPage="oci/reports">
              <OCIReports />
            </ProtectedRoute>,
            children: [
              {
                index: true,
                element: <OCIReports />,
              },
            ]
          },
        ],
      },
      {
        path: "email",
        children: [
          {
            path: "bulk",
            element: <ProtectedRoute requiredPage="email/bulk">
              <BulkEmail />
            </ProtectedRoute>,
            children: [
              {
                index: true,
                element: <BulkEmail />,
              },
            ]
          },
        ],
      },
      {
        path: "wiz",
        children: [
          {
            index: true,
            element: <ProtectedRoute requiredPage="wiz/reports">
               <WIZ />
            </ProtectedRoute>,
          },
          {
            path: "reports",
            element: <WIZ />,
          },
        ],
      },
      // ===== AWS LCCS (OutpostForge) capacity management module =====
      // Gated by the CES_LCCS_SLOTTING Cognito group: the parent ProtectedRoute
      // guards every child (renders <Outlet/> only when authorized).
      {
        path: "outposts",
        element: <ProtectedRoute requiredPage="outposts" />,
        children: [
          {
            index: true,
            element: <CapacityManagement tab="inventory" />,
          },
          {
            path: "edit",
            element: <CapacityManagement tab="edit" />,
          },
          {
            path: "sandbox",
            element: <OutpostSandbox />,
          },
          {
            path: "settings",
            element: <OutpostSettings />,
          },
          {
            path: ":outpostId",
            element: <CapacityManagement tab="inventory" />,
          },
          {
            path: ":outpostId/edit",
            element: <CapacityManagement tab="edit" />,
          },
          {
            path: ":outpostId/assets/:assetId/edit",
            element: <EditCapacity />,
          },
        ],
      },
      {
        path: "capacity-tasks",
        element: (
          <ProtectedRoute requiredPage="outposts">
            <TaskMonitor />
          </ProtectedRoute>
        ),
      },
    ],
  },
];
